<template>
  <div class="progress-timeline-text">
    <div class="progress-timeline-text__content">
      <div>
        <h3 class="progress-timeline-text__title">{{ title }}</h3>
        <p class="progress-timeline-text__paragraph">{{ paragraph }}</p>
      </div>
      <div>
        <h4 class="progress-timeline-text__list__title">{{ listTitle }}</h4>
        <ul class="progress-timeline-text__list">
          <li v-for="(item, index) in list" :key="index">{{ item }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProcessTimelineText",
  props: {
    content: Object
  },
  data() {
    return {
      title: this.content.title || "",
      paragraph: (this.content.text && this.content.text.paragraph) || "",
      listTitle: (this.content.text && this.content.text.listTitle) || "",
      list: (this.content.text && this.content.text.list) || []
    };
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.progress-timeline-text {
  &__content {
    @extend %page-margin-1;

    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    box-sizing: border-box;

    > * {
      width: 100%;
    }

    @media screen and (min-width: 769px) {
      > * {
        &:first-of-type {
          width: 60%;
        }
        &:last-of-type {
          width: 30%;
        }
      }
    }

  }
  &__title {
    @include typeset(body-medium);
    @extend %title-margin-1;
  }
  &__paragraph {
    @include typeset(body-medium);

    color: lighten(black, 40%);

    max-width: 100%;
    width: 35em;
  }

  &__list {
    @include typeset(body-medium);

    list-style: none;
    color: lighten(black, 40%);

    &__title {
      @include typeset(body-medium);
      @extend %title-margin-1;
    }
  }
}
</style>
